import { createAsyncThunk, createSlice, } from '@reduxjs/toolkit'
import { AppState } from '@app/store/state/app.state';
import { updateOutlookSyncState } from '@features/settings/services/UserService';
import { updateCurrentUser } from "@shared/store/auth.duck";

export interface OutlookSync {
  loading: boolean;
  success: boolean;
}

export const initialOutlookSync: OutlookSync = {
  loading: false,
  success: false,
}

export const setSync: any = createAsyncThunk(
  'outlookSync/setSync',
  async (state: boolean, thunkAPI) => {
    try {
      await updateOutlookSyncState(state)
      await thunkAPI.dispatch(updateCurrentUser(true));
      return state;
    } catch (err: any) {
      throw err;
    }
  }
);

const outlookSyncSlice = createSlice({
  name: 'outlookSync',
  initialState: initialOutlookSync,
  reducers: {
    reset: () => ({...initialOutlookSync}),
    closeOutlookSyncDialog: (state) => ({
      ...initialOutlookSync
    })
  },
  extraReducers: (builder) => {
    builder
      .addCase(setSync.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        success: true,
      }
    })
      .addCase(setSync.rejected, (state) => {
      return {
        ...state,
        loading: false,
        success: false,
      }
    })
      .addCase(setSync.pending, (state) => {
      return {
        ...state,
        loading: true,
        success: false,
      }
    });
  }
});

export default outlookSyncSlice.reducer


// Selectors
export const selectIsLoading = (state: AppState) => state.outlookSync.loading;
const selectIsSuccessful = (state: AppState) => state.outlookSync.success;
